export default __webpack_public_path__ + "static/media/post3.9f3b3e7a.jpg";